import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from "react-slick";
import Btn from '../../../../components/btns/Btn';

function Hero() {
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        fade: true,
        slidesToShow: 1,
    };
    let thumbOption = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 3,
        swipe: false,
        arrows: false,
        swipeToSlide: false,
        focusOnSelect: true,
    }
    return (
        <>
            <style>{`
        .hero-banner-container { overflow-x: hidden; }
        .banner-slide { min-height: 600px; position: relative; height: 100dvh; min-height: 700px; }
        .banner-slide-img { position: relative; height: 100%; }
        
        .banner-slide-img img { width: 100%; height: 100%; object-fit: cover; }
        .banner-slider .slick-dots li button { width: 12px !important; height: 12px; background: none; border-radius: 50%; background: var(--white) !important; margin: 5px 10px; position: relative; outline-color: var(--white) !important; }
        .banner-slider .slick-dots { bottom: 40px; }
        .banner-slider .slick-dots li button::before { content: ''; position: absolute; width: 34px; height: 34px; border: 1px solid var(--white); border-radius: 50%; top: 50%; left: 50%; transform: translate(-50%, -50%) scale(0); transition-property: all; transition-timing-function: cubic-bezier(.4, 0, .2, 1); transition-duration: .15s; transition-duration: .3s; transition-timing-function: cubic-bezier(.4, 0, 1, 1); }
        .banner-slider .slick-dots li button::after { content: ''; position: absolute; width: 1px; height: 0; border: 1px solid var(--white); border-radius: 50%; transition-property: all; transition-timing-function: cubic-bezier(.4, 0, .2, 1); transition-duration: .15s; transition-duration: .3s; transition-timing-function: cubic-bezier(.4, 0, 1, 1); bottom: -58px; left: 50%; transform: translateX(-50%); }
        .banner-slider .slick-dots li.slick-active button::before { transform: translate(-50%, -50%) scale(1); }
        .banner-slider .slick-dots li.slick-active button::after { height: 47px; }
        .banner-slider .slick-dots li.slick-active button { background: var(--white); }
        .banner-slider .slick-slide { opacity: 0; transition-timing-function: cubic-bezier(.4, 0, .2, 1); transition-duration: .1s; transition-duration: .3s; transition-timing-function: cubic-bezier(.4, 0, 1, 1); }
        .banner-slider .slick-active { opacity: 1; transition-timing-function: cubic-bezier(.4, 0, .2, 1); transition-duration: .1s; transition-duration: .3s; transition-timing-function: cubic-bezier(.4, 0, 1, 1); }
        .banner-slider .slick-cloned { opacity: 0.6; }
        .banner-slide-content-inn { opacity: 0; }
        .banner-slider .slick-active .banner-slide-content-inn { opacity: 1; }
        .banner-slider .banner-slide-content { position: absolute; top: 50%; width: 100%; height: 100%; transform: translateY(-50%); z-index: 99; padding: 140px 0; color: var(--white); font-size: 20px; line-height: 1.4; display: flex; align-items: center; }
        .banner-slider .banner-slide-content-cat { font-size: 18px; text-transform: uppercase; font-weight: 500; color: #fff !important; margin-bottom: 16px; letter-spacing: 0.2px; text-shadow: 0px 0px 20px #000000; }
        .banner-slider .banner-slide-content-cat span + span::before { content: '|'; color: var(--white); margin: 0 10px; font-weight: 400; }
        .banner-slider .banner-slide-content h1, .banner-slider .banner-slide-content h2 { color: #fff; font-size: 60px; font-weight: 600; margin-bottom: 20px; padding-left: 20px; border-left: 3px solid var(--primary); }
        .banner-slider .banner-slide-content p { color: #fff !important; max-width: 550px; }
        .banner-slider .banner-slide-cta { margin-top: 30px; }
        .banner-slider .slick-active  .banner-slide-content-inn>* { -webkit-animation-name: fadeInUpBig; animation-name: fadeInUpBig; -webkit-animation-delay: .4s; animation-delay: .4s; -webkit-animation-duration: 1s; animation-duration: 1s; -webkit-animation-fill-mode: both; animation-fill-mode: both; }
        .banner-slide-content-inn>:nth-child(2) { -webkit-transition-delay: 0.2s; transition-delay: 0.2s; }
        .banner-slide-content-inn>:nth-child(3) { -webkit-transition-delay: 0.3s; transition-delay: 0.3s; }
        .banner-slide-content-inn>:nth-child(4) { -webkit-transition-delay: 0.4s; transition-delay: 0.4s; }
        .banner-slide-content-inn>:nth-child(5) { -webkit-transition-delay: 0.5s; transition-delay: 0.5s; }
        .banner-thumb-sldier { z-index: 99; position: absolute; bottom: 6px; width: 800px; left: calc(50% - 92px); border-radius: 6px 6px 0 0; overflow: hidden; }
        .banner-thumb-icon { width: 44px; left: 22px; position: absolute; top: 50%; transform: translateY(-50%); }
        .banner-thumb-slide { background-color: rgb(0 202 224 / 70%); color: var(--white); font-size: 16px; padding-left: 80px; position: relative; min-height: 80px; display: flex !important; align-items: center; text-transform: uppercase; position: relative; z-index: 9; }
        .banner-thumb-slide::before { content: ''; position: absolute; transform: scaleX(0); width: 100%; height: 3px; transform-origin: left; background-color: var(--primary); left: 0; top: 0; }
        .banner-thumb-sldier .slick-current .banner-thumb-slide::before { animation: progress 4s linear infinite; animation-delay: .3s; }
        .banner-thumb-sldier .slick-current .banner-thumb-slide { background: rgb(7 26 33 / 85%); backdrop-filter: saturate(180%) blur(5px); }
        .banner-thumb-sldier .slick-slide + .slick-slide .banner-thumb-slide { border-left: 1px solid #dddddd; }
        .hero-shpe-1 img { position: absolute; top: 20px; right: 20px; z-index: 9; width: 200px; height: auto; display: block; opacity: .5; }
        @-webkit-keyframes fadeInUpBig {
            0% { opacity: 0; -webkit-transform: translate3d(0, 50px, 0); transform: translate3d(0, 50px, 0) }
            to { opacity: 1; -webkit-transform: translateZ(0); transform: translateZ(0) }
        }
        @keyframes fadeInUpBig {
            0% { opacity: 0; -webkit-transform: translate3d(0, 50px, 0); transform: translate3d(0, 50px, 0) }
            to { opacity: 1; -webkit-transform: translateZ(0); transform: translateZ(0) }
        }
        @keyframes progress {
            0% { -webkit-transform: scaleX(0); transform: scaleX(0) }
            100% { -webkit-transform: scaleX(1); transform: scaleX(1); }
        }
        @media (max-width:1399.98px) {
            .banner-thumb-sldier { left: auto; right: 0; border-radius: 6px 0 0 0; }
        }
        @media (max-width:991.98px) {
            .banner-slide { min-height: 620px; }
            .banner-slider .banner-slide-content { padding: 130px 0 100px }
            .banner-thumb-sldier { width: 100%; border-radius: 0; }
            .banner-thumb-slide { min-height: 70px; font-size: 14px; padding-left: 70px; }
            .banner-thumb-icon { width: 34px; left: 18px; }
        }
        @media (max-width:767.98px) {
            .banner-slider .banner-slide-content-cat { font-size: 16px; }
            .banner-slider .banner-slide-content h1, .banner-slider .banner-slide-content h2 { font-size: 44px; padding-left: 12px; }
            .hero-shpe-1 img { width: 90px; bottom: 80px; opacity:0; top: auto; transform: rotate(90deg); right: 13px; }
            .banner-slider .banner-slide-content { font-size: 16px; padding: 100px 0 100px;}
            .banner-slide-img::before { content: ''; position: absolute; width: 100%; height: 100%; top: 0; left: 0; background: #000; opacity: .4; }
        }
        @media (max-width:575.98px) {
            .banner-slider .banner-slide-content h1, .banner-slider .banner-slide-content h2{font-size:40px;}
            .banner-thumb-slide { font-size: 10px; padding-left: 40px; min-height: 50px; line-height: 12px; padding-right: 6px }
            .banner-thumb-icon { width: 22px; left: 10px; }
        }
    `}</style>
            <div className="content-container position-relative hero-banner-container">
                <div className="banner-slider">
                    <Slider {...settings} asNavFor={nav2} ref={(slider1) => setNav1(slider1)}>
                        <div className='banner-slide' >
                            <div className="banner-slide-img">
                                <img src="../assets/images/home/web.jpg" alt="" />
                            </div>
                            <div className="banner-slide-content">
                                <Container>
                                    <Row>
                                        <Col md={8} lg={7} className=''>
                                            <div className="banner-slide-content-inn pe-xl-5">
                                                <div className="banner-slide-content-cat">
                                                    <span>Innovate. Create. Elevate.</span>
                                                </div>
                                                <h1>Building the future one line of code at a time.</h1>
                                                <p>Customized Solutions, 100% User Friendly Invest your money in Developing a Brand, not just a website</p>
                                                <div className="banner-slide-cta">
                                                    <Btn to="/services/" type="default" value="Service" />
                                                    <Btn to="/contact/" type="primary" value="Contact" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                        <div className='banner-slide' >
                            <div className="banner-slide-img">
                                <img src="../assets/images/home/mobile.jpg" alt="" />
                            </div>
                            <div className="banner-slide-content">
                                <Container>
                                    <Row>
                                        <Col md={8} lg={7} className=''>
                                            <div className="banner-slide-content-inn pe-xl-5">
                                                <div className="banner-slide-content-cat">
                                                    <span>Mobile Application Development</span>
                                                </div>
                                                <h1>Mobile Development: Innovative Solutions Await!</h1>
                                                <p>Xipe Tech is a leading Mobile App Development Company in India we provide unique mobile application development services to develop solutions.</p>
                                                <div className="banner-slide-cta">
                                                    <Btn to="/services/" type="default" value="Service" />
                                                    <Btn to="/contact/" type="primary" value="Contact" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                        <div className='banner-slide' >
                            <div className="banner-slide-img">
                                <img src="../assets/images/home/seo.jpg" alt="" />
                            </div>
                            <div className="banner-slide-content">
                                <Container>
                                    <Row>
                                        <Col md={8} lg={7} className=''>
                                            <div className="banner-slide-content-inn pe-xl-5">
                                                <div className="banner-slide-content-cat">
                                                    <span>Innovate. Create. Elevate. </span>
                                                </div>
                                                <h1>Search Engine Optimization</h1>
                                                <p>XIPE TECH provides SEO services to business at affordable price with its specialist team of certified SEO experts. </p>
                                                <div className="banner-slide-cta">
                                                    <Btn to="/services/" type="default" value="Service" />
                                                    <Btn to="/contact/" type="primary" value="Contact" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </Slider>
                </div>
                <div className="banner-thumb-sldier">
                    <Slider {...thumbOption} asNavFor={nav1} ref={(slider2) => setNav2(slider2)}>
                        <div className='banner-thumb-slide' >
                            <div className="banner-thumb-icon">
                                <img src="../assets/images/home/icon2.png" alt="" />
                            </div>
                            Web Development
                        </div>
                        <div className='banner-thumb-slide' >
                            <div className="banner-thumb-icon">
                                <img src="../assets/images/home/icon1.png" alt="" />
                            </div>
                            Mobile <br />
                            Development
                        </div>
                        <div className='banner-thumb-slide' >
                            <div className="banner-thumb-icon">
                                <img src="../assets/images/home/icon3.png" alt="" />
                            </div>
                            SEO services
                        </div>
                    </Slider>
                </div>
                <div className="hero-shpe-1">
                    <img src="../assets/images/home/shape.png" alt="" />
                </div>
            </div>
        </>
    )
}

export default Hero